import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ConfigService, ListadaAgrupada } from "../../../infrastructure/services/config.service";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs";

@Component({
  selector: "sx-configurar-channel",
  templateUrl: "./configurar.channel.component.html"
})
export class ConfigurarChannelComponent implements OnInit {
  title: "CHANNEL";
  codOrganization: string;
  codSubscription: string;
  codChannel: string;
  codProducto: string;

  grupos: Observable<ListadaAgrupada[]>;
  cargando: Boolean = true;
  subsGetConfiguracion: Subscription;
  constructor(
    private aRoute: ActivatedRoute,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    const { title } = this.aRoute.snapshot.data;
    if (title) {
      this.title = title;
    }

    this.aRoute.params.subscribe((params: Params) => {
      // Parametros URL
      this.codOrganization = params["codorganizacion"];
      this.codSubscription = params["codsistema"];
      this.codChannel = params["codnegocio"];
      this.codProducto = params["codproducto"];
      this.grupos = this.configService.getConfiguracion(
        this.codOrganization,
        this.codSubscription,
        this.codChannel,
        this.codProducto
      );
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/configurar.channel.component.ts